import { render, staticRenderFns } from "./EmailsEdit.vue?vue&type=template&id=989f4264&scoped=true"
import script from "./EmailsEdit.vue?vue&type=script&lang=js"
export * from "./EmailsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989f4264",
  null
  
)

export default component.exports